import GeneralTab from "./Tabs/GeneralTab";
import AdvancedTab from "./Tabs/AdvancedTab";
import {useEffect, useState} from "react";
import {useNewProduct} from "../../../store/contexts/NewProductContext";
import axios from "axios";
import {useNavigate, useParams, useLocation} from "react-router-dom";
import AttributesTab from "./Tabs/AttributesTab";
import ReviewsTab from "./Tabs/ReviewsTab";
import {TYPES} from "../../../store/reducers/NewProductReducer";

const TabsWrapper = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const {product, setErrors, data, dispatch, setData} = useNewProduct();
  const [trigger, setTrigger] = useState(0);

  const {id} = useParams();

  const [tabs, setTabs] = useState({
    general: true,
    advanced: false,
    attributes: false,
    reviews: false
  });

  const triggerLoop = (id) => {
    setTrigger(id);
  }

  const handleTabChange = (tab) => {
    setTabs(
      Object.keys(tabs).reduce((accumulator, key) => {
        return {...accumulator, [key]: key === tab}
      }, {})
    )
  }

  useEffect(() => {
    if (id) {
      axios.get(`/products/${id}/edit`, {params: {shop_id: product?.shop_id}}).then(res => {
        setData(res.data);
        if (!product?.id) {
          dispatch({
            type: TYPES.SET_PRODUCT,
            payload: {...product, ...res.data.product}
          })
        }
      });
    } else {
      axios.get(`/products/create`, {params: {shop_id: product?.shop_id}}).then(response => {
        setData(response.data);
      })
    }
  }, [product?.shop_id, trigger])

  // const handleSubmit = (isDraft = false) => {
  //   let formData = new FormData();
  //
  //   const arrayProperties = [
  //     'product_visual_imagery',
  //     'attributes',
  //     'bundle',
  //     'addresses',
  //   ];
  //
  //   Object.entries(product).forEach(([property, value]) => {
  //     if (!arrayProperties.includes(property)) {
  //       formData.append(`${property}`, value ?? '');
  //     }
  //   });
  //
  //   console.log(product);
  //
  //   arrayProperties.forEach((column, index) => {
  //     product?.[column]?.forEach((item, key) => {
  //       Object.entries(item).forEach(([property, value]) => {
  //         formData.append(`${column}[${key}][${property}]`, value ?? '');
  //       });
  //     })
  //   });
  //
  //   if (product?.id) {
  //     formData.append('_method', 'PUT');
  //
  //     axios.post('products/' + product.id, formData)
  //       .then(function (res) {
  //         navigate("/products");
  //       }).catch(function (error) {
  //       if (error.response) {
  //         setErrors(error.response.data.errors || {});
  //       }
  //     });
  //   } else {
  //     if (isDraft) {
  //       formData.set("status", 4);
  //       formData.set("published", false);
  //     }
  //     console.log(formData.get("published"));
  //     axios.post('/products', formData).then(response => {
  //       navigate('/products');
  //     }).catch(error => {
  //       setErrors(error.response.data.errors)
  //     })
  //   }
  // }
  const handleSubmit = (isDraft = false) => {
    let formData = new FormData();

    const arrayProperties = [
      'product_visual_imagery',
      'attributes',
      'bundle',
      'addresses',
    ];

    // Append non-array properties to the FormData
    Object.entries(product).forEach(([property, value]) => {
      if (!arrayProperties.includes(property)) {
        formData.append(`${property}`, value ?? '');
      }
    });

    // Handle array properties, especially for product_visual_imagery
    arrayProperties.forEach((column) => {
      product?.[column]?.forEach((item, key) => {
        if (item.url && Array.isArray(item.url)) {
          // Loop through each file in the array
          item.url.forEach((file, fileIndex) => {
            // Use the same key but with the correct incremental index
            const newIndex = key + fileIndex;

            // Append each file and its corresponding type and alt value using the same index
            formData.append(`${column}[${newIndex}][url]`, file); // Append the file
            formData.append(`${column}[${newIndex}][type]`, item.type ?? 'image'); // Append the type
            formData.append(`${column}[${newIndex}][alt]`, item.alt ?? ''); // Append the alt text
          });
        } else {
          // Append other properties normally (non-array properties)
          Object.entries(item).forEach(([property, value]) => {
            formData.append(`${column}[${key}][${property}]`, value ?? '');
          });
        }
      });
    });

    if (product?.id) {
      formData.append('_method', 'PUT');

      axios.post('products/' + product.id, formData)
          .then(function (res) {
            navigate("/products");
          })
          .catch(function (error) {
            if (error.response) {
              setErrors(error.response.data.errors || {});
            }
          });
    } else {
      if (isDraft) {
        formData.set("status", 4);
        formData.set("published", false);
      }
      axios.post('/products', formData).then(response => {
        navigate('/products');
      }).catch(error => {
        setErrors(error.response.data.errors);
      });
    }
  };



  return (
    <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
      <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-n2">
        <li className="nav-item">
          <a className={`nav-link text-active-primary pb-4 ${tabs.general && "active"}`}
             style={{cursor: "pointer"}}
             onClick={() => handleTabChange("general")} data-bs-toggle="tab"
          >
            General
          </a>
        </li>

        <li className="nav-item">
          <a className={`nav-link text-active-primary pb-4 ${tabs.advanced && "active"}`}
             style={{cursor: "pointer"}}
             onClick={() => handleTabChange("advanced")} data-bs-toggle="tab">
            Advanced
          </a>
        </li>

        <li className="nav-item">
          <a className={`nav-link text-active-primary pb-4 ${tabs.attributes && "active"}`}
             style={{cursor: "pointer"}}
             onClick={() => handleTabChange("attributes")} data-bs-toggle="tab">
            Attributes
          </a>
        </li>
        {location.pathname != '/products/create' && (
          <li className="nav-item">
            <a className={`nav-link text-active-primary pb-4 ${tabs.reviews && "active"}`}
               style={{cursor: "pointer"}}
               onClick={() => handleTabChange("reviews")} data-bs-toggle="tab">
              Reviews
            </a>
          </li>
        )}
      </ul>

      <div className="tab-content">
        {tabs.general && <GeneralTab/>}
        {tabs.advanced && <AdvancedTab/>}
        {tabs.attributes && <AttributesTab/>}
        {tabs.reviews && <ReviewsTab triggerLoop={triggerLoop}/>}
      </div>

      {!tabs.reviews && (
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-light me-5"
            type="button"
            onClick={() => {
              navigate(-1)
            }}
          >
            Cancel
          </button>

          {
            location.pathname == '/products/create' && (
              <button
                onClick={() => {
                  handleSubmit(true)
                }}
                type="button"
                className="btn btn-light mr-3"
              >
                Save as draft
              </button>
            )
          }

          <button onClick={() => {
            handleSubmit(false)
          }} type="button" id="kt_ecommerce_add_product_submit"
                  className="btn btn-primary">
            <span className="indicator-label">Save Changes</span>
            <span className="indicator-progress">
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
          </button>
        </div>)
      }
    </div>
  )
}

export default TabsWrapper;